$(document).ready(function(){
    // Animate Progress Bar Bootstrap 100%
    $(".progress-bar-100").animate({
        width: "100%"
    }, 1000);
    // Animate Progress Bar Bootstrap 70%
    $(".progress-bar-70").animate({
        width: "70%"
    }, 1000);
});